var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tree"},_vm._l((_vm.sortedChildren),function(row,index){return _c('OrganizationsTreeItem',_vm._b({key:index,staticClass:"item",attrs:{"item":row}},'OrganizationsTreeItem',_vm.$props,false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }